/** Helpers for multi-job / multi-pipe /weld-status fan-out. */

export function normalizeJobNumbers(job_number) {
  if (!job_number) return [];
  const jobs = Array.isArray(job_number) ? job_number : [job_number];
  return jobs.map((j) => String(j).trim()).filter(Boolean);
}

export function normalizePipeIds(pipeIdOrIds) {
  if (pipeIdOrIds == null || pipeIdOrIds === '') return [];
  const list = Array.isArray(pipeIdOrIds) ? pipeIdOrIds : [pipeIdOrIds];
  return [...new Set(list.map((p) => String(p).trim()).filter(Boolean))];
}

export function weldDataRowKey(weld) {
  if (weld.id != null) return String(weld.id);
  const jn = Array.isArray(weld.job_number) ? weld.job_number.join('|') : weld.job_number;
  const pipe = weld.pipeId ?? weld.pipe_details_id ?? '';
  return `${weld.weldNumber ?? ''}-${jn ?? ''}-${pipe}`;
}

export function tagWeldRowsWithPipe(weldData, pipeId) {
  const id = pipeId == null || pipeId === '' ? null : String(pipeId);
  return (weldData || []).map((weld) => ({
    ...weld,
    pipeId: id,
    pipe_details_id: id != null ? (Number.isNaN(Number(id)) ? id : Number(id)) : weld.pipe_details_id,
  }));
}

export function mergeWeldDataResults(results) {
  const seen = new Set();
  const weldData = [];
  let statusCalculationMethod = 'Instantaneous';
  const partialErrors = [];

  results.forEach((result) => {
    if (!result) return;
    if (result.error) {
      partialErrors.push({
        pipeId: result.pipeId != null ? String(result.pipeId) : null,
        error: String(result.error),
      });
    }
    if (result.statusCalculationMethod) {
      statusCalculationMethod = result.statusCalculationMethod;
    }
    (result.weldData || []).forEach((weld) => {
      const key = weldDataRowKey(weld);
      if (seen.has(key)) return;
      seen.add(key);
      weldData.push(weld);
    });
  });

  return { weldData, statusCalculationMethod, partialErrors };
}
